export const BLANK          = '';
export const COMMA          = ',';
export const QUESTION_MARK  = '?';



// WEBPACK FOOTER //
// ./shared_critical/constants/string.js